import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

import { Alert } from './alert';

@Injectable()
export class AlertService {

    private _alerts$: BehaviorSubject<Alert[]>;
    private _dataStore: {
        alerts: Alert[];
    };
    private keepAfterNavigationChange = false;
    public _title$: BehaviorSubject<string>;
    public _cssClass$: BehaviorSubject<string>;

    constructor(
        private _router: Router
    ) {
        this._alerts$ = <BehaviorSubject<Alert[]>>new BehaviorSubject([]);
        this._title$ = <BehaviorSubject<string>>new BehaviorSubject<string>('');
        this._cssClass$ = <BehaviorSubject<string>>new BehaviorSubject<string>('');
        this._dataStore = { alerts: [] };

        // clear alert message on route change
        _router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterNavigationChange) {
                    // only keep for a single location change
                    this.keepAfterNavigationChange = false;
                } else {
                    // clear alert
                    this._dataStore.alerts = [];
                    this._title$.next('');
                    this._cssClass$.next('');
                    this._alerts$.next(Object.assign({}, this._dataStore).alerts);
                }
            }
        });
    }

    public getAlerts(): Observable<Alert[]> {
        return this._alerts$.asObservable();
    }

    public getTitle(): Observable<string> {
        return this._title$.asObservable();
    }
    
    public getCssClass(): Observable<string> {
        return this._cssClass$.asObservable();
    }

    public setAlert(type: string, message: string, keepAfterNavigationChange = false, associatedFormControlId: string, associatedFormControlLabel: string, routeTo: string): void {
        if (type == 'Success') {
            this._title$.next('Success!');
            this._cssClass$.next('alert alert-success');
        } else if (associatedFormControlId != null && associatedFormControlId != "") {
            this._title$.next('Please correct the highlighted form fields to continue.');
            this._cssClass$.next('alert alert-danger');
        } else {
            this._title$.next('Error!');
            this._cssClass$.next('alert alert-danger');
        }
        
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this._dataStore.alerts.push({ type: type, message: message, associatedFormControlId: associatedFormControlId, associatedFormControlLabel: associatedFormControlLabel, routeTo: routeTo });
        this._alerts$.next(Object.assign({}, this._dataStore).alerts);
    }

    public handleMessagesFromService(error: any, keepAfterNavigationChange: boolean) {
        if (error.status == 'PO100' && error.statusMsg != null && error.statusMsgType == "route") {
            this.setAlert("error", error.statusMsg, keepAfterNavigationChange, null, null, error.statusMsgRoute);
        } else if (error.status == 'PO100' && error.statusMsg != null) {
            this.setAlert("error", error.statusMsg, keepAfterNavigationChange, null, null, null);
        }
    }
    
    public closeAlert(alert: Alert): void {
        const index: number = this._dataStore.alerts.indexOf(alert);
        if (index >= 0) {
            this._dataStore.alerts.splice(index, 1);
        }
        this._alerts$.next(Object.assign({}, this._dataStore).alerts);
    }

    public clearAlerts(): void {
        this._dataStore.alerts = [];
        this._alerts$.next(Object.assign({}, this._dataStore).alerts);
    }
}
